exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iforgot {\n  float: right;\n  margin-top: -38px;\n}\n\n.logintext {\n  padding-right: 5px;\n}\n\n.logintext--left {\n  text-align: left;\n}\n\n.cmForm {\n  margin-bottom: 85px;\n}\n\n.code-form {\n  border-right: 1px solid #e3e3e3;\n}\n\n.login--no-bottom-margin {\n  margin-bottom: 0;\n}\n\ninput[type=checkbox] {\n  margin-top: 8px;\n}\n\n.checkbox--description {\n  margin-top: 8px;\n  float: right;\n}\n\n/** Media Queries **/\n\n@media (max-width: 450px) {\n  .section__welcome {\n    margin-bottom: 100px;\n  }\n\n  .section__login {\n    padding-top: 0px;\n    margin-top: 0px;\n  }\n  .section__login .w-col-12 {\n    padding: 0px;\n  }\n\n  .code-form {\n    border-right: none;\n  }\n}\n\n/** Media Queries **/\n\n@media (max-width: 960px) {\n  .code-form {\n    border-right: 1px solid transparent;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/login-user/login-user.component.scss
// module id = ../../../../../src/app/components/login-user/login-user.component.scss
// module chunks = main